import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_2 = { class: "max-w-[1040px]" }
const _hoisted_3 = {
  id: "sortable-block-order",
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_4 = { class: "flex justify-end" }
const _hoisted_5 = { class: "font-medium text-gray-700 flex items-center" }
const _hoisted_6 = { class: "draggable-invisible" }
const _hoisted_7 = { class: "draggable-invisible flex justify-end" }
const _hoisted_8 = { class: "space-y-5" }
const _hoisted_9 = { class: "space-y-5 border-t border-gray-100 pt-5" }
const _hoisted_10 = { class: "space-y-5 border-t border-gray-100 pt-5" }
const _hoisted_11 = {
  key: 1,
  class: "sortable-store-list overflow-x-auto p-2 -m-2"
}
const _hoisted_12 = { class: "font-medium text-gray-700 flex items-center" }
const _hoisted_13 = {
  key: 3,
  class: "border-t border-gray-100 pt-5"
}
const _hoisted_14 = { class: "flex justify-end" }
const _hoisted_15 = { class: "font-medium text-gray-700 flex items-center" }
const _hoisted_16 = { class: "min-w-0 break-words" }
const _hoisted_17 = { class: "break-words" }
const _hoisted_18 = { class: "draggable-invisible flex justify-end align-center" }

import { Bars3Icon, XCircleIcon } from '@heroicons/vue/24/outline'
import { Sortable } from '@shopify/draggable'
import { computed, reactive, ref } from 'vue'

import NeueTablist from '@/components/neue/NeueTablist.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'

import { buildMediaImageLocal } from './ModulesNeue.helpers'

const EMPTY_CARD = 'rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm'

export default {
  __name: 'ModulesNeue',
  setup(__props) {

const blockCols = [{ width: 'minmax(220px, 2fr)' }, { width: 'minmax(80px, 1fr)' }, { width: '100px' }]
const storeCols = [{ width: 'minmax(160px, 1fr)' }]
const linkCols = [{ width: 'minmax(140px, 1fr)' }, { width: 'minmax(180px, 2fr)' }, { width: '100px' }]

const BLOCKS = {
  StoreLinksPageModule: {
    name: 'Store list content block',
    description:
      'We automatically display stores based on your store visibility settings and locked/unlocked permissions for each customer. Drag a store by its handle to change the order.'
  },
  FormPageModule: {
    name: 'Form content block',
    description:
      'A form customers fill in on your home page. Set what the form says, what customers see once they send it, and an optional message we send them.'
  },
  TextContentPageModule: {
    name: 'Text content block',
    description: 'A header with a paragraph of text under it, on your home page.'
  },
  MediaPageModule: {
    name: 'Image content block',
    description: 'An image on your home page.'
  },
  LinkSectionPageModule: {
    name: 'Links content block',
    description:
      'A list of links on your home page. Click a link to change its text or where it goes, or drag it by its handle to change the order.'
  }
}
const LIST_BLOCK_TYPES = ['StoreLinksPageModule', 'LinkSectionPageModule']

const canCreateSite = computed(() => privilegeService.canAccessResourceAction('site', null, 'create'))
const canUpdateSite = computed(() => privilegeService.canAccessResourceAction('site', null, 'update'))
const canDeleteSite = computed(() => privilegeService.canAccessResourceAction('site', null, 'delete'))

const modal = reactive({
  block: { open: false },
  links: { open: false, text: '', url: '', moduleId: null, elementId: null }
})
const type = ref(null)
const hasUnsavedChanges = ref(false)
const loading = ref(true)
const local = reactive({
  form: {},
  text: {},
  image: {},
  links: {}
})
const sortables = ref([])

const root = computed(() => mapType('page').find(x => x.attributes.type === 'RootPage'))
const modules = computed(() =>
  mapRelationships(root.value?.relationships.page_modules.data).sort((a, b) => a.attributes.order - b.attributes.order)
)
const elements = mod => mapRelationships(mod.relationships.content_elements.data)
const form = mod => mapRelationship(mod.relationships.form?.data)
const stores = computed(() => mapType('store').sort((a, b) => a.attributes.order - b.attributes.order))

const newModuleOptions = computed(() =>
  Object.entries(BLOCKS)
    .filter(([type]) => type !== 'StoreLinksPageModule' || !modules.value.some(x => x.attributes.type === type))
    .map(([type, block]) => ({ name: block.name, value: type }))
)

const moduleName = mod =>
  BLOCKS[mod.attributes.type]?.name ?? mod.attributes.type.replace(/PageModule$/, ' content block')
const moduleDescription = mod =>
  BLOCKS[mod.attributes.type]?.description ?? "This kind of block can't be set up here yet."
const listsItems = mod => LIST_BLOCK_TYPES.includes(mod.attributes.type)

const openBlockModal = () => {
  if (!canCreateSite.value) return
  type.value = newModuleOptions.value[0].value
  modal.block.open = true
}

const openLinksModal = (moduleId, elementId) => {
  if (!canUpdateSite.value) return
  modal.links.open = true
  modal.links.text = local.links[moduleId].find(x => x.id === elementId)?.text
  modal.links.url = local.links[moduleId].find(x => x.id === elementId)?.url
  modal.links.moduleId = moduleId
  modal.links.elementId = elementId
}

const initSortables = () => {
  for (const sortable of sortables.value) sortable.destroy()
  sortables.value = []

  if (canUpdateSite.value) {
    sortables.value.push(
      new Sortable(document.querySelector('#sortable-block-order .tablist-body'), { handle: '.cursor-move' }).on(
        'sortable:stop',
        e => {
          if (!canUpdateSite.value) return
          if (e.data.oldIndex === e.data.newIndex) return
          const list = modules.value
          const moved = list.splice(e.data.oldIndex, 1)[0]
          list.splice(e.data.newIndex, 0, moved)
          list.map((x, i) =>
            api.call('PUT', `pages/${root.value.id}/page_modules/${x.id}`, {
              page_module: {
                order: i
              }
            })
          )
        }
      )
    )
  }

  if (canUpdateSite.value) {
    sortables.value.push(
      new Sortable(document.querySelectorAll('.sortable-store-list .tablist-body'), { handle: '.cursor-move' }).on(
        'sortable:stop',
        e => {
          if (!canUpdateSite.value) return
          if (e.data.oldIndex === e.data.newIndex) return
          const list = stores.value
          const moved = list.splice(e.data.oldIndex, 1)[0]
          list.splice(e.data.newIndex, 0, moved)
          list.map((x, i) =>
            api.call('PUT', `stores/${x.id}`, {
              store: {
                order: i
              }
            })
          )
        }
      )
    )
  }

  if (canUpdateSite.value) {
    for (const moduleId of Object.keys(local.links)) {
      sortables.value.push(
        new Sortable(document.querySelectorAll(`.sortable-links-${moduleId} .tablist-body`), {
          handle: '.cursor-move'
        }).on('sortable:stop', e => {
          if (!canUpdateSite.value) return
          if (e.data.oldIndex === e.data.newIndex) return
          const list = local.links[moduleId]
          const moved = list.splice(e.data.oldIndex, 1)[0]
          list.splice(e.data.newIndex, 0, moved)
          list.map((x, i) =>
            api.call('PUT', `pages/${root.value.id}/page_modules/${moduleId}`, {
              page_module: {
                content_elements_attributes: [
                  {
                    id: x.id,
                    order: i
                  }
                ]
              }
            })
          )
        })
      )
    }
  }
}

const setLocal = () => {
  for (const mod of modules.value) {
    if (mod.attributes.type === 'FormPageModule') {
      local.form[mod.id] = {}
      const f = form(mod)
      if (!f) continue
      local.form[mod.id] = {
        id: f.id,
        name: f.attributes.name,
        title: f.attributes.title,
        description: f.attributes.description,
        send: f.attributes.send_message_after_form_submission,
        explanation: f.attributes.modal_text,
        successTitle: f.attributes.success_title,
        successDescription: f.attributes.success_description,
        message: mapRelationship(f.relationships.message_template.data)?.attributes.body
      }
    }
    if (mod.attributes.type === 'TextContentPageModule') {
      local.text[mod.id] = {}
      const el = elements(mod)[0]
      if (!el) continue
      local.text[mod.id] = {
        id: el.id,
        header: el.attributes.primary_text,
        body: el.attributes.secondary_text
      }
    }
    if (mod.attributes.type === 'MediaPageModule') {
      local.image[mod.id] = {}
      const el = elements(mod)[0]
      if (!el) continue
      const a = mapRelationships(el.relationships.attachments.data)[0]
      local.image[mod.id] = buildMediaImageLocal(el, a)
    }
    if (mod.attributes.type === 'LinkSectionPageModule') {
      local.links[mod.id] = []
      const els = elements(mod)
      if (!els) continue
      local.links[mod.id] = els.map(el => ({
        id: el.id,
        text: el.attributes.primary_text,
        url: el.attributes.url
      }))
    }
  }
  hasUnsavedChanges.value = false
}

api
  .call(
    'GET',
    'pages?included=page_modules,page_modules.content_elements,page_modules.form,page_modules.form.message_template,page_modules.content_elements.attachments'
  )
  .then(setLocal)
  .then(initSortables)
  .then(() => {
    loading.value = false
  })

api.call('GET', 'stores?included=none')

const save = () => {
  if (!canUpdateSite.value) return
  for (const mod of modules.value) {
    if (mod.attributes.type === 'FormPageModule') {
      api.call('PUT', `pages/${root.value.id}/page_modules/${mod.id}`, {
        page_module: {
          form_attributes: {
            id: local.form[mod.id].id,
            name: local.form[mod.id].name,
            title: local.form[mod.id].title,
            description: local.form[mod.id].description,
            send_message_after_form_submission: local.form[mod.id].send,
            modal_text: local.form[mod.id].explanation,
            success_title: local.form[mod.id].successTitle,
            success_description: local.form[mod.id].successDescription,
            message_template_attributes: {
              body: local.form[mod.id].message
            }
          }
        }
      })
    }
    if (mod.attributes.type === 'TextContentPageModule') {
      api.call('PUT', `pages/${root.value.id}/page_modules/${mod.id}`, {
        page_module: {
          content_elements_attributes: [
            {
              type: 'TextContentElement',
              id: local.text[mod.id].id,
              primary_text: local.text[mod.id].header,
              secondary_text: local.text[mod.id].body
            }
          ]
        }
      })
    }
    if (mod.attributes.type === 'MediaPageModule') {
      api.call('PUT', `pages/${root.value.id}/page_modules/${mod.id}`, {
        page_module: {
          content_elements_attributes: [
            {
              type: 'AttachmentContentElement',
              id: local.image[mod.id].elementId,
              attachments_attributes: [{ id: local.image[mod.id].attachmentId, ...local.image[mod.id].image }]
            }
          ]
        }
      })
    }
  }
  hasUnsavedChanges.value = false
}

const saveLinksModal = () => {
  if (!canUpdateSite.value) return
  api
    .call('PUT', `pages/${root.value.id}/page_modules/${modal.links.moduleId}?included=content_elements`, {
      page_module: {
        content_elements_attributes: [
          {
            type: 'LinkContentElement',
            id: modal.links.elementId,
            primary_text: modal.links.text,
            url: modal.links.url
          }
        ]
      }
    })
    .then(setLocal)
  modal.links.open = false
}

const deleteLink = el => {
  if (!canUpdateSite.value) return
  api
    .call('PUT', `pages/${root.value.id}/page_modules/${modal.links.moduleId}?included=content_elements`, {
      page_module: {
        content_elements_attributes: [
          {
            id: el.id,
            _destroy: true
          }
        ]
      }
    })
    .then(setLocal)
}

const addModule = () => {
  if (!canCreateSite.value) return
  modal.block.open = false
  api
    .call('POST', `pages/${root.value.id}/page_modules`, {
      page_module: {
        type: type.value
      }
    })
    .then(() =>
      api.call(
        'GET',
        'pages?included=page_modules,page_modules.content_elements,page_modules.form,page_modules.form.message_template'
      )
    )
    .then(setLocal)
    .then(initSortables)
}

const deleteModule = mod => {
  if (!canDeleteSite.value) return
  api.call('DELETE', `pages/${root.value.id}/page_modules/${mod.id}`)
}

const setVisibility = (mod, visible) => {
  if (!canUpdateSite.value) return
  api.call('PUT', `pages/${root.value.id}/page_modules/${mod.id}`, {
    page_module: {
      visible
    }
  })
}

const saveImage = (mod, image) => {
  if (!canUpdateSite.value) return
  local.image[mod.id].image = image
  hasUnsavedChanges.value = true
}

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SaveBar = _resolveComponent("SaveBar")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_InputField = _resolveComponent("InputField")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueToggle = _resolveComponent("NeueToggle")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_ImageUploader = _resolveComponent("ImageUploader")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: "Content blocks",
        "save-status": true
      }),
      (canUpdateSite.value)
        ? (_openBlock(), _createBlock(_component_SaveBar, {
            key: 0,
            "has-unsaved-changes": hasUnsavedChanges.value,
            onOnDiscard: setLocal,
            onOnSave: save
          }, null, 8, ["has-unsaved-changes"]))
        : _createCommentVNode("", true)
    ]),
    main: _withCtx(() => [
      _createVNode(_component_TheModal, {
        "is-open": modal.block.open,
        "modal-title": "Add a content block",
        onCloseModal: _cache[2] || (_cache[2] = $event => (modal.block.open = false))
      }, {
        main: _withCtx(() => [
          _createVNode(_component_FormSection, null, {
            default: _withCtx(() => [
              _createVNode(_component_FormElement, null, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectInput, {
                    modelValue: type.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((type).value = $event)),
                    disabled: !canCreateSite.value,
                    name: "Type",
                    options: newModuleOptions.value
                  }, null, 8, ["modelValue", "disabled", "options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_NeueButton, {
            type: "secondary",
            onClick: _cache[1] || (_cache[1] = $event => (modal.block.open = false))
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          (canCreateSite.value)
            ? (_openBlock(), _createBlock(_component_NeueButton, {
                key: 0,
                type: "primary",
                onClick: addModule
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("Save", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_TheModal, {
        "is-open": modal.links.open,
        "modal-title": modal.links.elementId ? 'Edit link' : 'Add a link',
        onCloseModal: _cache[6] || (_cache[6] = $event => (modal.links.open = false))
      }, {
        main: _withCtx(() => [
          _createVNode(_component_FormSection, {
            onKeyup: _withKeys(saveLinksModal, ["enter"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormElement, null, {
                default: _withCtx(() => [
                  _createVNode(_component_InputField, {
                    modelValue: modal.links.text,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((modal.links.text) = $event)),
                    name: "Display text",
                    disabled: !canUpdateSite.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_FormElement, null, {
                default: _withCtx(() => [
                  _createVNode(_component_InputField, {
                    modelValue: modal.links.url,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((modal.links.url) = $event)),
                    name: "URL",
                    disabled: !canUpdateSite.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_NeueButton, {
            type: "secondary",
            onClick: _cache[5] || (_cache[5] = $event => (modal.links.open = false))
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          (canUpdateSite.value)
            ? (_openBlock(), _createBlock(_component_NeueButton, {
                key: 0,
                type: "primary",
                onClick: saveLinksModal
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("Save", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-open", "modal-title"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NeueLoading, { loading: loading.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(SettingsSection, {
                title: "Block order",
                description: "Content blocks show on your storefront's home page in this order. Drag a block by its handle to move it up or down.",
                plain: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_3, [
                    _createVNode(NeueTablist, null, {
                      head: _withCtx(() => [
                        _createVNode(TablistHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: blockCols,
                              header: "",
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _cache[15] || (_cache[15] = _createElementVNode("div", null, "Type", -1)),
                                _cache[16] || (_cache[16] = _createElementVNode("div", null, "Enabled", -1)),
                                _createElementVNode("div", _hoisted_4, [
                                  (canCreateSite.value)
                                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                                        key: 0,
                                        type: "secondary",
                                        onClick: openBlockModal
                                      }, {
                                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                          _createTextVNode("+ Block", -1)
                                        ]))]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modules.value, (mod) => {
                          return (_openBlock(), _createBlock(TablistRow, {
                            key: mod.id,
                            class: "draggable-source"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TablistGrid, {
                                columns: blockCols,
                                class: "items-center"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["-ml-4 px-3 -mt-2 -mb-2 py-2", canUpdateSite.value ? 'cursor-move' : 'cursor-not-allowed opacity-50'])
                                    }, [
                                      _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                    ], 2),
                                    _createTextVNode(" " + _toDisplayString(moduleName(mod)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(mod.attributes.visible ? 'Yes' : 'No'), 1),
                                  _createElementVNode("div", _hoisted_7, [
                                    (canDeleteSite.value)
                                      ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                                          key: 0,
                                          class: "cursor-pointer h-6 w-6 hover:text-black",
                                          onClick: $event => (deleteModule(mod))
                                        }, null, 8, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, modules.value.length]
                  ]),
                  (!modules.value.length)
                    ? (_openBlock(), _createBlock(_component_EmptyState, {
                        key: 0,
                        plural: "content blocks",
                        class: _normalizeClass(EMPTY_CARD)
                      }, {
                        default: _withCtx(() => [
                          (canCreateSite.value)
                            ? (_openBlock(), _createBlock(_component_NeueButton, {
                                key: 0,
                                type: "secondary",
                                onClick: openBlockModal
                              }, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createTextVNode("+ Block", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modules.value, (mod) => {
                return (_openBlock(), _createBlock(SettingsSection, {
                  key: mod.id,
                  title: moduleName(mod),
                  description: moduleDescription(mod),
                  plain: listsItems(mod)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex items-center justify-between gap-6", listsItems(mod) && 'rounded-xl border border-gray-200 bg-white px-6 py-5 shadow-sm'])
                    }, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "min-w-0" }, [
                        _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Show on your storefront"),
                        _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Off hides this block from your home page.")
                      ], -1)),
                      _createVNode(_component_NeueToggle, {
                        disabled: !canUpdateSite.value,
                        "model-value": mod.attributes.visible,
                        onChange: e => setVisibility(mod, e)
                      }, null, 8, ["disabled", "model-value", "onChange"])
                    ], 2),
                    (local.form[mod.id])
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "space-y-6 border-t border-gray-100 pt-5",
                          onInput: _cache[8] || (_cache[8] = $event => (hasUnsavedChanges.value = true))
                        }, [
                          _createElementVNode("div", _hoisted_8, [
                            _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700" }, "Internal", -1)),
                            _createVNode(_component_InputField, {
                              modelValue: local.form[mod.id].name,
                              "onUpdate:modelValue": $event => ((local.form[mod.id].name) = $event),
                              name: "Name",
                              disabled: !canUpdateSite.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700" }, "Visible to customer", -1)),
                            _createVNode(_component_InputField, {
                              modelValue: local.form[mod.id].title,
                              "onUpdate:modelValue": $event => ((local.form[mod.id].title) = $event),
                              name: "Name",
                              disabled: !canUpdateSite.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                            _createVNode(_component_InputField, {
                              modelValue: local.form[mod.id].description,
                              "onUpdate:modelValue": $event => ((local.form[mod.id].description) = $event),
                              name: "Description",
                              disabled: !canUpdateSite.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                            _createVNode(_component_InputField, {
                              modelValue: local.form[mod.id].explanation,
                              "onUpdate:modelValue": $event => ((local.form[mod.id].explanation) = $event),
                              name: "Explanation text",
                              disabled: !canUpdateSite.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700" }, "On success", -1)),
                            _createVNode(_component_InputField, {
                              modelValue: local.form[mod.id].successTitle,
                              "onUpdate:modelValue": $event => ((local.form[mod.id].successTitle) = $event),
                              name: "Title",
                              disabled: !canUpdateSite.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                            _createVNode(_component_InputField, {
                              modelValue: local.form[mod.id].successDescription,
                              "onUpdate:modelValue": $event => ((local.form[mod.id].successDescription) = $event),
                              name: "Description",
                              disabled: !canUpdateSite.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                            _createVNode(_component_NeueToggle, {
                              modelValue: local.form[mod.id].send,
                              "onUpdate:modelValue": $event => ((local.form[mod.id].send) = $event),
                              name: "Send message after form submission",
                              disabled: !canUpdateSite.value,
                              onChange: _cache[7] || (_cache[7] = $event => (hasUnsavedChanges.value = true))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                            (local.form[mod.id].send)
                              ? (_openBlock(), _createBlock(_component_InputArea, {
                                  key: 0,
                                  modelValue: local.form[mod.id].message,
                                  "onUpdate:modelValue": $event => ((local.form[mod.id].message) = $event),
                                  disabled: !canUpdateSite.value,
                                  name: "Message"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                              : _createCommentVNode("", true)
                          ])
                        ], 32))
                      : (mod.attributes.type === 'StoreLinksPageModule')
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(NeueTablist, null, {
                              head: _withCtx(() => [
                                _createVNode(TablistHeader, null, {
                                  default: _withCtx(() => [
                                    _createVNode(TablistGrid, {
                                      columns: storeCols,
                                      header: ""
                                    }, {
                                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                        _createElementVNode("div", null, "Stores", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stores.value, (store) => {
                                  return (_openBlock(), _createBlock(TablistRow, {
                                    key: store.id,
                                    class: "draggable-source"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(TablistGrid, { columns: storeCols }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["-ml-4 px-3 -mt-2 -mb-2 py-2", canUpdateSite.value ? 'cursor-move' : 'cursor-not-allowed opacity-50'])
                                            }, [
                                              _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                            ], 2),
                                            _createTextVNode(" " + _toDisplayString(store.attributes.store_name), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ], 512)), [
                            [_vShow, stores.value.length]
                          ])
                        : (local.text[mod.id])
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "space-y-6 border-t border-gray-100 pt-5",
                              onInput: _cache[9] || (_cache[9] = $event => (hasUnsavedChanges.value = true))
                            }, [
                              _createVNode(_component_InputField, {
                                modelValue: local.text[mod.id].header,
                                "onUpdate:modelValue": $event => ((local.text[mod.id].header) = $event),
                                name: "Header",
                                disabled: !canUpdateSite.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                              _createVNode(_component_InputArea, {
                                modelValue: local.text[mod.id].body,
                                "onUpdate:modelValue": $event => ((local.text[mod.id].body) = $event),
                                name: "Body",
                                disabled: !canUpdateSite.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                            ], 32))
                          : (mod.attributes.type === 'MediaPageModule')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(!canUpdateSite.value && 'pointer-events-none opacity-50')
                                }, [
                                  _createVNode(_component_ImageUploader, {
                                    class: "w-64",
                                    "existing-upload-thumbnail-path": local.image[mod.id]?.image?.secure_url,
                                    onUploaded: images => saveImage(mod, images[0]),
                                    onRemovedUpload: $event => (saveImage(mod, null))
                                  }, null, 8, ["existing-upload-thumbnail-path", "onUploaded", "onRemovedUpload"])
                                ], 2)
                              ]))
                            : (mod.attributes.type === 'LinkSectionPageModule')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _withDirectives(_createElementVNode("div", {
                                    class: _normalizeClass([`sortable-links-${mod.id}`, "overflow-x-auto p-2 -m-2"])
                                  }, [
                                    _createVNode(NeueTablist, null, {
                                      head: _withCtx(() => [
                                        _createVNode(TablistHeader, null, {
                                          default: _withCtx(() => [
                                            _createVNode(TablistGrid, {
                                              columns: linkCols,
                                              header: "",
                                              class: "items-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _cache[24] || (_cache[24] = _createElementVNode("div", null, "Link text", -1)),
                                                _cache[25] || (_cache[25] = _createElementVNode("div", null, "URL", -1)),
                                                _createElementVNode("div", _hoisted_14, [
                                                  (canUpdateSite.value)
                                                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                                                        key: 0,
                                                        type: "secondary",
                                                        onClick: $event => (openLinksModal(mod.id))
                                                      }, {
                                                        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                          _createTextVNode(" + Link ", -1)
                                                        ]))]),
                                                        _: 1
                                                      }, 8, ["onClick"]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(local.links[mod.id], (link) => {
                                          return (_openBlock(), _createBlock(TablistRow, {
                                            key: link.id,
                                            class: _normalizeClass(["draggable-source", canUpdateSite.value ? 'cursor-pointer' : 'cursor-not-allowed opacity-50']),
                                            onClick: $event => (canUpdateSite.value && openLinksModal(mod.id, link.id))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(TablistGrid, {
                                                columns: linkCols,
                                                class: "items-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_15, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["-ml-4 px-3 -mt-2 -mb-2 py-2", canUpdateSite.value ? 'cursor-move' : 'cursor-not-allowed opacity-50'])
                                                    }, [
                                                      _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                                    ], 2),
                                                    _createElementVNode("span", _hoisted_16, _toDisplayString(link.text), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_17, _toDisplayString(link.url), 1),
                                                  _createElementVNode("div", _hoisted_18, [
                                                    (canUpdateSite.value)
                                                      ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                                                          key: 0,
                                                          class: "cursor-pointer h-6 w-6 hover:text-black",
                                                          onClick: _withModifiers($event => (deleteLink(link)), ["stop"])
                                                        }, null, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["class", "onClick"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], 2), [
                                    [_vShow, local.links[mod.id]?.length]
                                  ]),
                                  (!local.links[mod.id]?.length)
                                    ? (_openBlock(), _createBlock(_component_EmptyState, {
                                        key: 0,
                                        plural: "links",
                                        class: _normalizeClass(EMPTY_CARD)
                                      }, {
                                        default: _withCtx(() => [
                                          (canUpdateSite.value)
                                            ? (_openBlock(), _createBlock(_component_NeueButton, {
                                                key: 0,
                                                type: "primary",
                                                onClick: $event => (openLinksModal(mod.id))
                                              }, {
                                                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                                  _createTextVNode("+ Link", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["title", "description", "plain"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }))
}
}

}